// Low-level Web Audio DSP helpers: distortion/saturation curves + reverb impulse.

export function makeDistortionCurve(amount) {
  const k = amount * 3;
  const n = 44100;
  const curve = new Float32Array(n);
  for (let i = 0; i < n; i++) {
    const x = (i * 2) / n - 1;
    curve[i] = ((3 + k) * x * 20 * (Math.PI / 180)) / (Math.PI + k * Math.abs(x));
  }
  return curve;
}

// Soft-clip (tanh) saturation curve — adds warmth/harmonics so 808s & synths
// cut through and sound "finished" instead of thin.
export function makeSatCurve(amount) {
  const n = 1024;
  const curve = new Float32Array(n);
  const k = amount * 10 + 1;
  for (let i = 0; i < n; i++) {
    const x = (i * 2) / n - 1;
    curve[i] = Math.tanh(k * x) / Math.tanh(k);
  }
  return curve;
}

export function makeImpulse(ctx, seconds, decay) {
  const rate = ctx.sampleRate;
  const len = rate * seconds;
  const impulse = ctx.createBuffer(2, len, rate);
  for (let c = 0; c < 2; c++) {
    const data = impulse.getChannelData(c);
    for (let i = 0; i < len; i++) {
      data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, decay);
    }
  }
  return impulse;
}
